<template>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    width="50%"
    :before-close="closeDialog">
    <span>留言</span>
    <span slot="footer" class="dialog-footer">
    <el-button size="medium" @click="closeDialog">取 消</el-button>
    <el-button size="medium" type="primary" @click="closeDialog">确 定</el-button>
  </span>
  </el-dialog>
</template>

<script>
export default {
  props: ['dialogVisible'],
  data () {
    return {
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeNotificationDialog')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/secPages/LeaveMsg.vue